var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalInstrument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5-.5h128a1204.757 1204.757 0 0029 29.5 19298.289 19298.289 0 01151 16 6.977 6.977 0 012.5 3.5 342.33 342.33 0 010 37c-1.066 3.063-3.233 4.563-6.5 4.5a18285.45 18285.45 0 00-147 15L233 130.5c-.5 16.33-.667 32.663-.5 49a60.931 60.931 0 0111 .5c1.833.5 3 1.667 3.5 3.5.667 108 .667 216 0 324-.69 1.85-1.856 3.184-3.5 4h-127c-1.644-.816-2.81-2.15-3.5-4-.667-108-.667-216 0-324 .5-1.833 1.667-3 3.5-3.5a60.931 60.931 0 0111-.5v-45c-8.673.166-17.34 0-26-.5-1.833-.5-3-1.667-3.5-3.5a4032.298 4032.298 0 010-127c.69-1.85 1.856-3.184 3.5-4z",
    opacity: 0.992
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f1f0",
    d: "M112.5 14.5h15v105h-15v-105z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#404750",
    d: "M225.5 59.5v15c-3.59.044-6.09 1.71-7.5 5-.5 13.33-.667 26.663-.5 40h-75v-105h75c-.167 13.004 0 26.004.5 39 .863 4.018 3.363 6.018 7.5 6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2732",
    d: "M225.5 74.5v-15c3.175-.34 5.341-2.007 6.5-5l1-29 14 14a756.122 756.122 0 010 55l-14 14-1-30c-1.638-2.234-3.805-3.567-6.5-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#404750",
    d: "M375.5 56.5v21a10795.453 10795.453 0 00-113 11v-43c37.646 3.865 75.313 7.531 113 11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2732",
    d: "M375.5 56.5a153.558 153.558 0 0022 2v17c-7.401.14-14.735.807-22 2v-21z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#82868b",
    d: "M195.5 134.5v45h-53v-45h53z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#61676e",
    d: "M195.5 134.5h22v45h-22v-45z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M127.5 194.5h105v15h-105v-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e2e2",
    d: "M210.5 224.5c.327 9.848-.006 19.514-1 29-15.532-16.156-32.866-18.322-52-6.5-16.504 15.525-19.004 33.025-7.5 52.5 14.134 15.495 30.634 18.662 49.5 9.5 3.5-2.669 6.833-5.502 10-8.5a6891.114 6891.114 0 011 166h-83v-242h83z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c5c7",
    d: "M210.5 224.5h22v242h-22a6891.114 6891.114 0 00-1-166c10.431-15.627 10.431-31.294 0-47 .994-9.486 1.327-19.152 1-29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M209.5 253.5c10.431 15.706 10.431 31.373 0 47a123.207 123.207 0 01-10 8.5c-18.866 9.162-35.366 5.995-49.5-9.5-11.504-19.475-9.004-36.975 7.5-52.5 19.134-11.822 36.468-9.656 52 6.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#40474f",
    d: "M174.5 254.5c18.678-.488 27.844 8.512 27.5 27-5.66 15.891-16.493 21.058-32.5 15.5-11.213-7.641-14.38-17.808-9.5-30.5 3.541-5.72 8.374-9.72 14.5-12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M127.5 481.5h105v15h-105v-15z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInstrument);
export default __webpack_public_path__ + "static/media/medicalInstrument.1224c3fc.svg";
export { ForwardRef as ReactComponent };